import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import StreamingPage from './StreamingPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/streaming" element={<StreamingPage />} />
      </Routes>
    </Router>
  )
}

export default App;